module.exports = __webpack_public_path__ + "img/industry-innovation-and-infrastructure.226356e3.png";